$(document).ready(function() {
    $('.header-navigation-wrapper .header__heading-link img').replaceWith(`
        <img srcset="//cdn.shopify.com/s/files/1/0860/0420/3856/files/agg-colour_black_200x.png?v=1734356649, //cdn.shopify.com/s/files/1/0860/0420/3856/files/agg-colour_black_400x.png?v=1734356649 2x" 
             src="//cdn.shopify.com/s/files/1/0860/0420/3856/files/agg-colour_black_200x.png?v=1734356649" 
             loading="lazy" 
             class="header__heading-logo w-100 h-auto ver-alg-mid d-inline-block" 
             alt="aggautostyling" 
             width="200" 
             height="48">
    `);
});
//cdn.shopify.com/s/files/1/0860/0420/3856/files/agg-colour_black_200x.png?v=1734356649